import { CSSProperties, FC, PropsWithChildren } from 'react'
import { CustomThemeInterface } from '@atbay/theming'
import { StyledText } from './Typography.styles'
import { TFontVariant } from '@/core/theme'

interface TypographyProps extends PropsWithChildren {
    variant?: TFontVariant
    className?: string
    component?: 'p' | 'span' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    noWrap?: boolean
    testId?: string
    color?: CSSProperties['color']
    onClick?: (e: any) => void
    whiteSpaceRule?:
        | 'pre'
        | 'break-spaces'
        | 'normal'
        | 'nowrap'
        | 'pre-line'
        | 'pre-wrap'
    textTransformRule?: 'uppercase' | 'lowercase' | 'capitalize' | 'none'
}

const Typography: FC<TypographyProps> = ({
    children,
    variant = 'xs-regular',
    color,
    className,
    component,
    testId,
    noWrap = true,
    onClick,
    whiteSpaceRule = 'normal',
    textTransformRule = 'none',
}) => {
    return (
        <StyledText
            textVariant={variant as keyof CustomThemeInterface['fonts']}
            className={className}
            component={component}
            noWrap={noWrap}
            testId={testId}
            color={color || 'inherit'}
            onClick={onClick}
            whiteSpaceRule={whiteSpaceRule}
            textTransform={textTransformRule}
        >
            {children}
        </StyledText>
    )
}

export default Typography
